import { useCallback } from "react";
import { usePromptInjection } from "src/hooks/useToolActions";
import { useStore } from "src/stores";
import type { SkillDraftOperation } from "src/types";

type SkillDraftAgentPromptValues = {
  operation?: SkillDraftOperation;
  sourceSkillId?: string;
};

const previewByOperation = {
  create: "Draft a new skill",
  edit: "Draft a skill edit",
  duplicate: "Draft a skill copy",
};

const skillDraftAgentOperationLabel: Record<SkillDraftOperation, string> = {
  create: "create a new skill",
  edit: "edit an existing skill",
  duplicate: "duplicate an existing skill",
};

export const buildSkillDraftAgentPrompt = (
  values?: SkillDraftAgentPromptValues | null
) => {
  return [
    `I want to ${
      skillDraftAgentOperationLabel[values?.operation ?? "create"]
    }.`,
    "",
    ...(values?.sourceSkillId
      ? [`Source skill ID: ${values.sourceSkillId}`, ""]
      : []),
    "Return an editable draft_skill card for this request. Keep the requested operation and any source skill ID, and wait for me to click Apply before creating, editing, or duplicating any skill.",
  ].join("\n");
};

export const useOpenSkillDraftAgentPanel = () => {
  const { injectPrompt } = usePromptInjection();
  const { agentStore, uiStore } = useStore();

  return useCallback(
    (values?: SkillDraftAgentPromptValues | null) => {
      const prompt = buildSkillDraftAgentPrompt(values);

      agentStore.navigateToThread(null);
      uiStore.setIsRightPanelOpen(true);
      injectPrompt({
        prompt,
        preview: previewByOperation[values?.operation ?? "create"],
        source: "draft-skill",
        replaceInput: true,
        submit: false,
      });
    },
    [agentStore, injectPrompt, uiStore]
  );
};
